import { createContext, useContext, useState, useCallback } from "react";
import translations, { LANGUAGES } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("studio_lang") || "de-CH";
  });

  const changeLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem("studio_lang", newLang);
  }, []);

  const t = useCallback((key, fallback) => {
    const dict = translations[lang] || translations["de-CH"];
    const chDict = translations["de-CH"];
    return dict[key] || chDict[key] || fallback || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};
